import { Component, ChangeDetectionStrategy, OnInit } from '@angular/core';
import { ActionButtonOption } from '../group-info/study-group-info';
import { ActivityLogger } from '../../activities/activity-logger';
import { SampleTrackingStorage } from '../sample-tracking-storage';
import { IBreadcrumb, BreadcrumbService } from '../shared/breadcrumb-service/breadcrumb.service';
import { UrlBuilder } from '../../core';

@Component({
    selector: 'sample-tracking-preferences',
    template: require('./sample-tracking-preferences.component.html'),
    styles: [require('./sample-tracking-preferences.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SampleTrackingPreferencesComponent implements OnInit {
    public actionButtonOption: ActionButtonOption = { text: 'View Group', isRouteToDashboard: false };

    constructor(
        activityLogger: ActivityLogger,
        private urlBuilder: UrlBuilder,
        private breadcrumbService: BreadcrumbService) {
        
        activityLogger.logActivity('View User Preferences - Sample Tracking');
    }

    public ngOnInit() {
        this.breadcrumbService.clear();

        let routeData: IBreadcrumb = {
            label: 'My Preferences',
            url: this.urlBuilder.esa().sampletracking().preference().url()
        };
        this.breadcrumbService.AddRouterToBreadCrumb(routeData);
    }
}